export default __webpack_public_path__ + "static/media/button talkback.186fe8a4.png";